import angular from 'angular';
import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';

let inject = [
    '$scope',
    '$state',
    '$rootScope',
    'SharedService',
    '$uibModal',
    '$timeout',
    '$stateParams',
    'ContactService'
];

class ContactDetailController {

    constructor($scope, $state, $rootScope, SharedService, $uibModal, $timeout, $stateParams, ContactService) {
        this.$state = $state;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.SharedService = SharedService;
        this.$stateParams = $stateParams;
        this.operatingCenterId = this.$stateParams.contactId || '';
        this.contactService = ContactService;

        this.activateMap = false;
        this.coordinates = {
            latitude: '0',
            longitude: '0'
        };
        this.marker = {
            id: 0,
            latitude: this.coordinates.latitude,
            longitude: this.coordinates.longitude,
            title: "m0",
        };
        this.zoom = 15;

        this.operatingCenterData = {};
    }

    $onInit() {
        this.modal = angular.element('#imgContactModal');
        this.img = angular.element('#imgContact');
        this.modalImg = angular.element("#img01");
        this.captionText = angular.element("#caption");

        this.contactService.getContactLocations(this.operatingCenterId).then(response => {

            angular.forEach(response, (value, key) => {

                this.operatingCenterData = value[0];
                this.operatingCenterData["city"] = key;

                this.coordinates.latitude = this.operatingCenterData.latitude;
                this.coordinates.longitude = this.operatingCenterData.longitude;

                this.marker.latitude = this.operatingCenterData.latitude;
                this.marker.longitude = this.operatingCenterData.longitude;

            });
        });
    }

    openImgModal() {
        this.modal[0].style.display = "block";
        this.modalImg[0].src = this.img[0].src;
        this.captionText[0].innerHTML = this.img[0].alt;

    }

    closeImgModal() {
        this.modal[0].style.display = "none";
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }
}

ContactDetailController.$inject = inject;

export default ContactDetailController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/contact-detail/contact-detail.controller.js
 **/